import './App.css';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import FAQPage from './pages/FAQPage';
import OrganizersPage from './pages/OrganizersPage';
import CompetitorsPage from './pages/CompetitorsPage';
import PartnersPage from './pages/PartnersPage';
import BestPage from './pages/BestPage';
import ITLabsPage from './pages/ITLabsPage';
import GalerijaPage from './pages/GalerijaPage';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/organizers" element={<OrganizersPage />} />
        <Route path="/competitors" element={<CompetitorsPage />} />
        <Route path="/partners" element={<PartnersPage />} />
        <Route path="/best" element={<BestPage />} />
        <Route path="/itlabs" element={<ITLabsPage />} />
        <Route path="/galerija" element={<GalerijaPage />} />
      </Routes>
    </Router>
  );
}

export default App;